import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isVisible"],
  _excluded2 = ["isVisible"],
  _excluded3 = ["isMobileMenuOpen", "openLabel", "closeLabel"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { memo } from 'react';
import { MobileMenuTriggerContainer, NoJsMenuTrigger, TriggerButton, TriggerSvg } from "./mobile-menu-trigger.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var HamburgerSvg = function HamburgerSvg(_ref) {
  var isVisible = _ref.isVisible,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(TriggerSvg, _objectSpread(_objectSpread({
    isVisible: isVisible
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2",
      d: "M4 7h16M4 12.5h16M4 18h16"
    })
  }));
};
var CloseSvg = function CloseSvg(_ref2) {
  var isVisible = _ref2.isVisible,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(TriggerSvg, _objectSpread(_objectSpread({
    isVisible: isVisible
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M5 5L19 19M19 5L5 19",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round"
    })
  }));
};
var MobileMenuTrigger = function MobileMenuTrigger(_ref3) {
  var isMobileMenuOpen = _ref3.isMobileMenuOpen,
    openLabel = _ref3.openLabel,
    closeLabel = _ref3.closeLabel,
    buttonProps = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(MobileMenuTriggerContainer, {
    "data-testid": "mobile-menu-trigger",
    children: [/*#__PURE__*/_jsx(NoJsMenuTrigger, {}), /*#__PURE__*/_jsxs(TriggerButton, _objectSpread(_objectSpread({
      "aria-expanded": isMobileMenuOpen,
      "aria-label": isMobileMenuOpen ? closeLabel : openLabel
    }, buttonProps), {}, {
      children: [/*#__PURE__*/_jsx(CloseSvg, {
        id: "close-menu-svg",
        isVisible: isMobileMenuOpen
      }), /*#__PURE__*/_jsx(HamburgerSvg, {
        id: "open-menu-svg",
        isVisible: !isMobileMenuOpen
      })]
    }))]
  });
};
export default /*#__PURE__*/memo(MobileMenuTrigger);